// Old links keep working (CR_Manager_vs_User_role P14): /sites/:id, /counts?site=, /settings/sites?edit= and the
// dashboard / alert / zone-sign links land on the place's page, found by the site's type. The query string is kept
// (?zone= from a zone sign, ?tab=), and a zone filter opens the Assets tab where it applies.
import { useTranslation } from 'react-i18next';
import { seesWarehouses, useSession } from '../auth/session';
import { Navigate, useParams, useSearchParams } from 'react-router';
import { Loading, LoadError, Page } from '../components/Page';
import { useSites } from '../data/queries';
import { placePath, placeTab } from '../lib/places';

export function SiteRedirect() {
  const { siteId = '' } = useParams();
  const [params] = useSearchParams();
  const { t } = useTranslation();
  const sites = useSites();
  if (sites.isLoading) return <Loading />;
  const site = sites.data?.find((s) => s.site_id === siteId);
  if (!site)
    return (
      <Page title={t('places.not_found')}>
        <LoadError error={sites.error ?? new Error(t('places.not_found'))} />
      </Page>
    );
  const tab = params.get('tab') ?? (params.get('zone') ? 'assets' : null);
  return <Navigate to={placePath(site, placeTab(tab), params)} replace />;
}

/** The first list for the person: Warehouses, or Projects for a project user (who has no warehouses). */
export function HomeListRedirect() {
  const { me } = useSession();
  return <Navigate to={seesWarehouses(me) ? '/warehouses' : '/projects'} replace />;
}

/** /counts?site=X → X's Stock counts tab; /counts → the person's first list. */
export function CountsRedirect() {
  const [params] = useSearchParams();
  const site = params.get('site');
  return site ? <Navigate to={`/sites/${site}?tab=counts`} replace /> : <HomeListRedirect />;
}

/** /settings/labels (the page left on 2026-09-15): ?tab=zones&site=X → X's Assets tab (Zone signs), else Assets. */
export function LabelsRedirect() {
  const [params] = useSearchParams();
  const site = params.get('tab') === 'zones' ? params.get('site') : null;
  return <Navigate to={site ? `/sites/${site}?tab=assets` : '/assets'} replace />;
}

/** /settings/sites?edit=X → X's page with the edit dialog open; /settings/sites → the Warehouses list. */
export function SiteSettingsRedirect() {
  const [params] = useSearchParams();
  const edit = params.get('edit');
  return edit ? <Navigate to={`/sites/${edit}?edit=1`} replace /> : <HomeListRedirect />;
}
